export default __webpack_public_path__ + "static/media/sh-call-active.a15e99a0.svg";